import gql from 'graphql-tag';

export const actionStepFragment = gql`{
  id name status type solutionType company{id}
}`
